// export const CHART_JS_MODULE_NAME = "chart.js";
import {UserGranredAuthorityName} from "../../router/const/AllPermitions";

export const SortablePaginationModuleName = 'SortableNavigationModuleName';
export const CustomerListModuleName = 'CustomerListModuleName';
export const NgMessagesModule = 'ngMessages';
export const AngularMaterialTableModuleName: string = 'md.data.table';
export const AddressModuleName = 'AddressModuleName';
export const LoggingFundedModuleName = UserGranredAuthorityName.LOGGING_FUNDED;
export const ManualImportModuleName = UserGranredAuthorityName.MANUAL_IMPORT;
export const LoggingModuleName = "LOGGING";
export const DirectMailerLogsModuleName = "DIRECT_MAILER_LOGS";
export const CustomersModuleName = "CUSTOMERS";
export const BranchModuleName = 'BRANCH';
export const EmployeeModuleName = "EMPLOYEES";
export const SchedulingModuleName = "SCHEDULED_TASKS";
export const RedirectModuleName = "REDIRECTS";
export const StatisticModuleName = "STATISTICS";
export const InstanceConfigurationModuleName = "INSTANCE_CONFIGURATION";
export const CalculationsModuleName = "CALCULATIONS";
export const OpportunitiesModuleName = 'OPPORTUNITIES';
export const USERS_MODULE_NAME = "USERS";
export const DynamicOrderingModuleName = 'DynamicOrderingModule';
export const CustomerSubscriptionModuleName = 'CustomerSubscriptionModuleName';
export const BranchServiceModuleName = 'BranchServiceModuleName';
export const LqbPricerParamsServiceModuleName = 'LqbPricerParamsServiceName';
export const SchedulingServiceModuleName = "SCHEDULING_SERVICE_MODULE_NAME";
export const ANGULAR_CIRCULAR_DATE_TILE_PICKER_MODULE_NAME = 'angular.circular.datetimepicker';
export const CUSTOMER_PROFILE_MODULE_NAME = "CUSTOMER_PROFILE_MODULE_NAME";
export const CustomerServiceModuleName = "CUSTOMER_SERVICE_MODULE_NAME";
export const NAVIGATABLE_MODULE_NAME = "NAVIGATABLE_MODULE_NAME";
export const RedirectServiceModuleName = "REDIRECT_SERVICE_MODULE_NAME";
export const EmployeeServiceModuleName = "EMPLOYEE_SERVICE_MODULE";
export const EMPLOYEE_PROFILE_MODULE_NAME = "EMPLOYEE_PROFILE_MODULE";
export const EMPLOYEE_PROFILE_SERVICE_MODULE_NAME = "EMPLOYEE_DETAILS_SERVICE_MODULE_NAME";
export const MD_COLOR_PICKER_MODULE_NAME = "mdColorPicker";
export const MULTICOLUMN_LIST_MODULE_NAME = 'MULTICOLUMN_LIST_MODULE_NAME';
export const OpportunityActionsModuleName = 'OPPORTUNITY_ACTIONS_MODULE';
export const ActionsServiceModuleName = 'ActionsServiceModuleName';
export const OpportunitiesServiceModuleName = 'OPPORTUNITIES_SERVICE_MODULE_NAME';
export const ADMINISTRATOR_MODULE_NAME = 'ADMINISTRATOR_MODULE_NAME';
export const EmployeeAutocompleteModuleName = 'EMPLOYEE_AUTOCOMPLETE_MODULE_NAME';
export const LqbPricerLogModuleName = 'LQB_PRICER_LOG_MODULE_NAME';
export const BrandServiceModuleName = 'BRAND_MODULE_NAME';
export const IMAGE_CROPPER_MODULE_NAME = 'IMAGE_CROPPER_MODULE_NAME';
export const UserServiceModuleName = "USER_SERVICE_NAME";
export const UserSettingsModuleName = "USER_SETTINGS_NAME";
export const OpportunityFilterModuleName = 'OpportunityFilterModuleName';
export const DragularModuleName = 'dragularModule';
export const FilterComponentsModuleName = "FilterComponentsModuleName";
export const ChartJsModuleName = 'ChartJs';
export const CroppieModuleName = "croppie";
export const ThemeColourPickerModuleName = 'ThemeColourModule';
export const AngularJsSliderModuleName = 'rzSlider';
export const VAccordionModuleName = 'vAccordion';
export const AnimateModuleName = 'ngAnimate';
export const WebSocketProviderModuleName = 'WEB_SOCKET_PROVIDER_NAME';
export const CampaignsModuleName = 'CampaignsModuleName';
export const CampaignsServiceModuleName = 'CampaignsServiceModuleName';
export const CardConfigModuleName = 'CardConfigModuleName';
export const ActionStatusModuleName = 'ActionStatusModuleName';
export const ConversionLogModuleName = 'ConversionLogModuleName';
export const LoanArchieModuleName = 'LoanArchieModuleName';
export const ContactProfileModuleName = 'ContactProfileModuleName';
export const LeadModuleName = 'LeadModuleName';
export const LeadProfileModuleName = 'LeadProfileModuleName';
export const PartnerModuleName = 'PartnerModuleName'
export const PartnerProfileModuleName = 'PartnerProfileModuleName'